import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import "../styles/Home.css";

const HomeDesktop = () => {
  return (
    <div className="desktop-home">
      <header className="desktop-hero">
        <div className="desktop-hero__content">
          <img src="/logo.png" alt="Logo Find ID" className="logo-img" />
          
          <h1 className="as">Retrouvez ou déclarez vos pièces d&apos;identité</h1>
          <p>
            Notre platforme vous accompagne pour centraliser vos
            démarches : déclarer un document perdu, signaler une pièce ramassée
            ou consulter vos demandes en cours.
          </p>
          <div className="desktop-actions">
            <Link className="desktop-btn desktop-btn--found" to="/piece-ramace">
              Déclarer une pièce ramassée
            </Link>
            <Link className="desktop-btn desktop-btn--lost" to="/piece-perdu">
              Déclarer une pièce perdue
            </Link>
            <Link className="desktop-btn desktop-btn--outline" to="/mes-declarations">
              Mes déclarations
            </Link>
          </div>
        </div>
        <div className="desktop-hero__image">
          <img src="/images/affichehome.webp" alt="Illustration sécurité des documents" />
        </div>
      </header>

      <main className="desktop-main">
        <section className="desktop-section">
          {/* <h2>Deux expériences adaptées</h2>
          <div className="desktop-grid">
            <article className="desktop-card">
              <h3>Version ordinateur</h3>
              <p>
                Naviguez confortablement sur grand écran, suivez vos dossiers et
                remplissez les formulaires en quelques clics.
              </p>
            </article>
            <article className="desktop-card">
              <h3>Version mobile</h3>
              <p>
                L&apos;interface mobile reprend les mêmes actions dans un format
                compact, optimisé pour l&apos;utilisation en déplacement.
              </p>
            </article>
            <article className="desktop-card">
              <h3>Notifications audio</h3>
              <p>
                Un message sonore est disponible sur la page mobile pour attirer
                l&apos;attention des utilisateurs en situation de terrain.
              </p>
            </article>
          </div> */}

          <div className="desktop-impact">
            <div>
              <p className="desktop-impact__intro">
                Find ID est plus qu&apos;un outil pratique : c&apos;est une plateforme
                citoyenne qui simplifie les démarches tout en renforçant la
                confiance collective.
              </p>
              <h3 className="desktop-impact__title">Impact social au quotidien</h3>
              <ul className="desktop-impact__list">
                <li>Réduction du stress lié à la perte de documents importants.</li>
                <li>Facilitation du retour des pièces grâce à une communauté solidaire.</li>
                <li>Diminution des risques d’usurpation d’identité.</li>
                <li>Accès rapide à une solution fiable et sécurisée.</li>
                <li>Renforcement de la citoyenneté numérique.</li>
                <li>Modernisation des pratiques de restitution des documents.</li>
                <li>Gain de temps pour les citoyens et les administrations.</li>
                <li>Encouragement à l’honnêteté et au civisme (déclarer une pièce trouvée).</li>
                <li>Contribution à la confiance entre les citoyens.</li>
                <li>Diminution de la surcharge administrative dans les services publics.</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="desktop-section desktop-section--highlight">
          <div className="desktop-highlight">
            <div>
              <h2 className="as">Nous soutenir</h2>
              <p>
              Soutenir notre initiative, c’est contribuer à un projet utile, innovant 
              et profondément ancré dans les réalités de notre société.
              </p>
              <div className="desktop-actions">
                {/* <Link className="desktop-btn desktop-btn--found" to="/admin-login">
                  Accéder à l&apos;espace admin
                </Link> */}
<a className="desktop-btn desktop-btn--outline" href="tel:783314995">
  Nous soutenir
</a>

              </div>
            </div>
            <div className="desktop-highlight__image">
              <img src="/images/argents.webp" alt="Illustration de documents" />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default HomeDesktop;
